import { InjectionToken } from '@angular/core';

export const USER_INTERCEPTOR = new InjectionToken<IUserService>('USER_SERVICE');

export interface IUserService {}
